import { useState, useEffect } from "react";
import makeApi, { URLS } from "Utils/apiURL";
import Utils from "Utils/utils";

const useTeamMembersAndTeams = () => {
  const [members, setMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    makeApi({ url: URLS.getTeamData, method: "GET" })
      .then(res => {
        if (cancelled) return;
        const groups = res?.data?.groups || [];
        const teamMembers = res?.data?.teamMembers || [];
        const allMembers = [];
        const allTeams = [];
        const addMember = m => {
          if (m?.memberId && !allMembers.some(existing => existing.memberId === m.memberId)) {
            allMembers.push({ memberId: m.memberId, name: Utils.getFullNameFromUserInfo(m) });
          }
        };
        groups.forEach(item => {
          const { group = {}, members: groupMembers = [] } = item || {};
          if (group?.id) {
            allTeams.push({ id: group.id, name: group.name });
          }
          groupMembers.forEach(addMember);
        });
        teamMembers.forEach(addMember);
        setMembers(allMembers);
        setTeams(allTeams);
      })
      .catch(err => console.error("useTeamMembersAndTeams: failed to load team members", err))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  return { members, teams, loading };
};

export default useTeamMembersAndTeams;
